import { render, staticRenderFns } from "./bf-header.vue?vue&type=template&id=3d54a832&scoped=true&lang=pug&"
import script from "./bf-header.vue?vue&type=script&lang=js&"
export * from "./bf-header.vue?vue&type=script&lang=js&"
import style0 from "./bf-header.vue?vue&type=style&index=0&id=3d54a832&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54a832",
  null
  
)

export default component.exports